import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

export const cardVariants = cva(
  'relative rounded-lg border border-solid border-border bg-white shadow-sm',
  {
    variants: {
      padding: {
        none: '',
        sm: 'p-4',
        md: 'p-6',
      },
    },
    defaultVariants: {
      padding: 'md',
    },
  },
);

type KoobCardProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> &
  VariantProps<typeof cardVariants>;

const KoobCard = React.forwardRef<HTMLDivElement, KoobCardProps>(
  ({ padding, children, ...props }, ref) => (
    <div ref={ref} className={cardVariants({ padding })} {...props}>
      {children}
    </div>
  ),
);

KoobCard.displayName = 'KoobCard';

export default KoobCard;
